import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Endpoints } from 'src/app/shared/config/endpoints';
import { GeneralService } from '../general.service';

@Injectable({
  providedIn: 'root',
})
export class TicketBulkService {
  orgID;
  userID: any;
  ticketApi = this.config.ticketUrl;
  settingApi = this.config.settingsApi
  chatApi = this.config.chatServiceUrl
  department: any;
  emailSignature$ = new BehaviorSubject<{ emailSignature: string; isEnabled: boolean } | null>(null);
  defaultInboundIntegrations = {
    "bulkEmail": false,
    "bulkSMS": false,
    "id": 0,
    "inboundCall": false,
    "inboundEmail": false,
    "inboundSMS": false,
    "inboundWhatsApp": false,
    "inboundClickatellWhatsApp": false,
    "inboundVonageWhatsApp": false,
    "inboundWebWhatsApp": false,
    "inboundFacebook": false,
    "inboundInstagram": false,
    "inboundTiktok": false,
    "inboundThreads": false,
    "inboundLinkedin": false,
    "inboundTwitter": false,
    "inboundTwillioWhatsapp": false,
    "inboundMetaWhatsapp": false,
    "inboundYoutube": false,
    "inboundSnapchat": false,
    "inboundWebchat": false,
    "inboundTelegram": false,
    "inboundDiscord": false,
  }
  constructor(private http: HttpClient,
    private config: Endpoints,
    private gs: GeneralService) {
    this.orgID = this.gs.orgID;
    this.userID = this.gs.user.id;
    this.department = JSON.parse(localStorage.getItem("departmentInfo"));
  }

  // Ticket Bulk Api Config
  private get TicketBulkAPI() {
    const url = this.config.settingsUrl + this.config.ticketBulk.baseurl;
    return url;
  }

  // CREATE =>  POST: add a new Auth to the server
  createTicketBulk(payload): Observable<any> {
    return this.http
      .post<any>(this.TicketBulkAPI + this.config.ticketBulk.save, payload);
  }
  saveIntegrations(payload) {
    const body = {
      ...this.defaultInboundIntegrations,
      ...payload,
      orgID: this.orgID
    }
    return this.http.post(`${this.settingApi}/saveIntegration`, body);
  }
  getIntegrationsByCompany(): Observable<any> {
    return this.http.get(`${this.settingApi}/${this.orgID}/getIntegrationsByCompany`);
  }

  getIntegrationsByDepartment(): Observable<any> {
    return this.http.get(`${this.settingApi}/${this.orgID}/${this.department.id}/getIntegrationsByDepartment`);
  }

  saveInboundComms(payload) {
    const body = { ...payload, orgID: this.orgID, departmentID: this.department ? this.department.id : '' };
    return this.http.post(this.ticketApi + '/saveInboundComms', body);
  }

  addEmailSignature(payload) {
    const body = { ...payload, orgID: this.orgID, userID: this.userID };
    return this.http.post(this.chatApi + '/email-signature/add', body);
  }

  updateEmailSignatureStatus(payload){
    const body = {isEnabled: payload, orgID : this.orgID, userID: this.userID};
    return this.http.post(this.chatApi + '/email-signature/status', body);
  }

  uploadEmailSignature(payload){
    const body = {...payload};
    return this.http.post(this.chatApi + '/email-signature/signature-image', body);
  }

  getInboundComms() {
    return this.http.get(this.ticketApi + `/1/${this.orgID}/getTicketInboundComms`)
  }

  getInboundCommsByDepartment(departmentID) {
    return this.http.get(this.ticketApi + `/1/${this.orgID}/${departmentID}/getTicketInboundComms`)
  }

  getEmailSignature() {
    return this.http.get(this.chatApi + `/email-signature/${this.userID}/${this.orgID}/`).pipe(
      tap((res: any) => {
        if (res && res.data) {
          this.emailSignature$.next(res.data);
        }
      })
    );
  }

  download3cxTemplate() {
    return this.http.get(`${this.chatApi}/crm-file-gen/${this.orgID}`, { responseType: 'blob' });
  }

  updateA365Integrations(payload) {
    const body = {
      ...payload,
      orgID: this.orgID
    }
    return this.http.put(`${this.settingApi}/update/a365/integration`, body);
  }

}
